// Generated by @speria-jp/json-schema-validator-gen
// https://github.com/speria-jp/json-schema-validator-gen
// Do not edit manually
// ============================================================================
// Validation Types (auto-generated)
// ============================================================================

type ValidationResult<T> =
  | { success: true; data: T }
  | { success: false; issues: ValidationIssue[] };

interface ValidationIssue {
  code: ValidationIssueCode;
  path: (string | number)[];
  message: string;
  expected: string;
  received: string;
}

type ValidationIssueCode =
  | "invalid_type"
  | "invalid_value"
  | "too_small"
  | "too_big"
  | "invalid_string"
  | "not_integer"
  | "not_unique"
  | "unrecognized_key"
  | "missing_key";

interface ValidationOptions {
  abortEarly?: boolean;
}

// ============================================================================
// Validation Helpers (auto-generated)
// ============================================================================

function _getType(value: unknown): string {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
}

function _invalidType(issues: ValidationIssue[], path: (string | number)[], expected: string, value: unknown): void {
  const received = _getType(value);
  issues.push({ code: "invalid_type", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _missingKey(issues: ValidationIssue[], path: (string | number)[], key: string): void {
  const expected = `object with required property "${key}"`;
  const received = `object without property "${key}"`;
  issues.push({ code: "missing_key", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooSmall(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_small", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooBig(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_big", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidString(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_string", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidValue(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_value", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _notInteger(issues: ValidationIssue[], path: (string | number)[], value: number): void {
  issues.push({ code: "not_integer", path, message: `Expected integer, received ${value}`, expected: "integer", received: String(value) });
}

function _notUnique(issues: ValidationIssue[], path: (string | number)[]): void {
  issues.push({ code: "not_unique", path, message: "Expected array with unique items, received array with duplicate items", expected: "array with unique items", received: "array with duplicate items" });
}

function _unrecognizedKey(issues: ValidationIssue[], path: (string | number)[], expected: string, key: string): void {
  issues.push({ code: "unrecognized_key", path, message: `Expected ${expected}, received ${key}`, expected, received: key });
}


export type MessagingConfigSchema = {
    meta: {
        appId: "messaging";
        version: "karte/messagingSchema/20250825";
    };
    data: {
        name: string;
        customPrompt?: string;
    };
};


export function validateMessagingConfigSchema(value: unknown, options?: ValidationOptions): ValidationResult<MessagingConfigSchema> {
    const issues: ValidationIssue[] = [];
    const abortEarly = options?.abortEarly ?? false;
    if (!(typeof value === "object" && value !== null && !Array.isArray(value))) {
        _invalidType(issues, [], "object", value);
        if (abortEarly)
            return { success: false, issues };
    }
    else {
        if (!("meta" in value)) {
            _missingKey(issues, [], "meta");
            if (abortEarly)
                return { success: false, issues };
        }
        if (!("data" in value)) {
            _missingKey(issues, [], "data");
            if (abortEarly)
                return { success: false, issues };
        }
        if ("meta" in value) {
            if (!(typeof value.meta === "object" && value.meta !== null && !Array.isArray(value.meta))) {
                _invalidType(issues, ["meta"], "object", value.meta);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                if (!("appId" in value.meta)) {
                    _missingKey(issues, ["meta"], "appId");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if (!("version" in value.meta)) {
                    _missingKey(issues, ["meta"], "version");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if ("appId" in value.meta) {
                    if (value.meta.appId !== "messaging") {
                        _invalidValue(issues, ["meta", "appId"], "\"messaging\"", JSON.stringify(value.meta.appId));
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                if ("version" in value.meta) {
                    if (value.meta.version !== "karte/messagingSchema/20250825") {
                        _invalidValue(issues, ["meta", "version"], "\"karte/messagingSchema/20250825\"", JSON.stringify(value.meta.version));
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                for (const key1 in value.meta) {
                    if (!["appId", "version"].includes(key1)) {
                        _unrecognizedKey(issues, ["meta", key1], `one of known properties (${["appId", "version"].join(", ")})`, key1);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
            }
        }
        if ("data" in value) {
            if (!(typeof value.data === "object" && value.data !== null && !Array.isArray(value.data))) {
                _invalidType(issues, ["data"], "object", value.data);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                if (!("name" in value.data)) {
                    _missingKey(issues, ["data"], "name");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if ("name" in value.data) {
                    if (!(typeof value.data.name === "string")) {
                        _invalidType(issues, ["data", "name"], "string", value.data.name);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                if ("customPrompt" in value.data) {
                    if (!(typeof value.data.customPrompt === "string")) {
                        _invalidType(issues, ["data", "customPrompt"], "string", value.data.customPrompt);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                for (const key2 in value.data) {
                    if (!["name", "customPrompt"].includes(key2)) {
                        _unrecognizedKey(issues, ["data", key2], `one of known properties (${["name", "customPrompt"].join(", ")})`, key2);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
            }
        }
        for (const key3 in value) {
            if (!["meta", "data"].includes(key3)) {
                _unrecognizedKey(issues, [key3], `one of known properties (${["meta", "data"].join(", ")})`, key3);
                if (abortEarly)
                    return { success: false, issues };
            }
        }
    }
    if (issues.length > 0) {
        return { success: false, issues };
    }
    return { success: true, data: value as MessagingConfigSchema };
}
export function unsafeValidateMessagingConfigSchema(value: unknown): MessagingConfigSchema {
    const result = validateMessagingConfigSchema(value, { abortEarly: true });
    if (!result.success) {
        throw new Error("Validation failed: value is not MessagingConfigSchema");
    }
    return result.data;
}
